'use strict';

angular.module('shiftTraderApp')
  .controller('ProfileCtrl', function ($scope, $filter, Session, ServerUrls, WorkPeriods, TimeService,
                                       AvailabilitySets, $state, flash, UserPermissionsService, OverrideTokens,
                                       user, positions, me) {
    $scope.user = user;
    $scope.me = me;
    $scope.thisWeeksSchedule = [];
    $scope.currentWeek = TimeService.getWeekTwixFromMoment(TimeService.getNowInStoreTime());
    $scope.todayDate = TimeService.getNowInStoreTime();

    $scope.currentAvailSet = _.find($scope.user.availability_sets, function(availSet) {
      return availSet.$isApproved() && availSet.$isInEffect() && availSet.active;
    });


    $scope.accessToken = Session.getAccessToken();
    $scope.serverUrl = ServerUrls.current.railsApi;

    $scope.state = {
      scheduleLoaded: false,
      rawPermissions: null,
      derivedPermissions: null
    };

    if ($scope.user.time_off_rules) {
      $scope.blackoutData = {
        numApproved: $filter('activeApprovedBlackoutRules')($scope.user.time_off_rules).length,
        numUnapproved: $filter('activeUnapprovedBlackoutRules')($scope.user.time_off_rules).length
      };
    }

    $scope.requestUserContactInfo = function(contactType) {
      $scope.user.$requestUserContactInfo(contactType)
        .then(function(data) {
          console.log(data);
          if (_.has(data, 'message')) {
            flash.success = data.message;
          }
        });
    };


    var permissionsToLookUp = [
      'users.change_my_avatar',
      'users.view_info_in_org',
      'users.change_avatar',
      'users.update_name',
      'users.update_email_address',
      'users.resend_activation',
      'users.view_stats_in_org',
      'users.can_receive_daily_digest',
      'trades.can_receive_trade_notif',

      'user_org_configs.change_allowable_flags',
      'user_org_configs.change_my_contact_sharing',

      'users_positions.create',
      'users_positions.set_inactive',

      'communication_subscriptions.manage_for_self',
      'communication_subscriptions.view_for_self',
      'communication_subscriptions.manage',
      'communication_subscriptions.view_in_org',

      'availability_rules.view_mine',
      'availability_rules.view_in_org',
      'days_off.request_for_self',
      'days_off.request_for_other',
      'days_off.create_override',
      'availability_sets.create',
      'availability_sets.view_target',
      'availability_sets.create_override',

      'memberships.add_note',
      'memberships.view_notes',
      'memberships.view_external_ids',
      'memberships.change_active_state',
      'memberships.change_external_ids',
      'memberships.change_role',

      'permission_sets.view_all_in_org'
    ];

    var theOrgId = Session.getCurrentOrgId() || $scope.user.memberships[0].organization_id;
    UserPermissionsService.getCanDict(permissionsToLookUp, theOrgId)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
      });

    function processRawPermissions() {
      var myProf = $scope.me.id === $scope.user.id;
      var rawPerm = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        showManageNotifications: (myProf && rawPerm['communication_subscriptions.manage_for_self'] && rawPerm['communication_subscriptions.view_for_self'] ||
        !myProf && rawPerm['communication_subscriptions.manage'] && rawPerm['communication_subscriptions.view_in_org']),
        canUpdateEmail: rawPerm['users.update_email_address'],
        showRequestDayOff: myProf && rawPerm['days_off.request_for_self'],
        showCreateDayOff: !myProf && rawPerm['days_off.request_for_other'],
        canShowDaysOff: (myProf && rawPerm['availability_rules.view_mine'] ||
        !myProf && rawPerm['availability_rules.view_in_org']),
        canChangeAvatar: (myProf && rawPerm['users.change_my_avatar'] ||
        !myProf && rawPerm['users.change_avatar']),
        showContactSharingSettings: (myProf && rawPerm['user_org_configs.change_my_contact_sharing'] ||
        !myProf && rawPerm['users.view_info_in_org']),
        canChangeContactSharing: (myProf && rawPerm['user_org_configs.change_my_contact_sharing']),
        canChangeMembershipState: rawPerm['memberships.change_active_state'],
        canViewNotes: rawPerm['memberships.view_notes'],
        canEditNotes: rawPerm['memberships.add_note'],
        canViewUserStats: rawPerm['users.view_stats_in_org'],
        canShowEmail: myProf || rawPerm['users.view_info_in_org'] || $scope.user.memberships[0].user_org_config.share_email_with_coworkers,
        canShowPhone: myProf || rawPerm['users.view_info_in_org'] || $scope.user.memberships[0].user_org_config.share_phone_with_coworkers,
        canChangeAllowableFlags: rawPerm['user_org_configs.change_allowable_flags'],
        canManagePositions: rawPerm['users_positions.create'] && rawPerm['users_positions.set_inactive'],
        canChangeMembershipPermissions: rawPerm['memberships.change_role'] && rawPerm['permission_sets.view_all_in_org'],
        changeAllowableFlags: rawPerm['user_org_configs.change_allowable_flags'],
        canResendActivation: rawPerm['users.resend_activation'],
        canViewAvailabilityPage: rawPerm['availability_sets.create'],
        canViewTargetHours: rawPerm['availability_sets.view_target'],
        showDayOffOverrides: rawPerm['days_off.create_override'],
        showAvailabilityOverrides: rawPerm['availability_sets.create_override']
      };

      $scope.state.derivedPermissions.showContactArea = (myProf ||
      rawPerm['users.view_info_in_org'] ||
      $scope.user.memberships[0].user_org_config.share_phone_with_coworkers ||
      $scope.user.memberships[0].user_org_config.share_email_with_coworkers);

      $scope.state.derivedPermissions.showEditVitals = ($scope.state.derivedPermissions.canUpdateEmail ||
      rawPerm['users.update_name'] || rawPerm['memberships.view_external_ids']);
    }

    $scope.goToEmployeeListWithPosition = function(positionId) {
      $state.go('employees', {positionId: positionId});
    };

    function loadOverrideTokens() {
      OverrideTokens.getOne({
        user_id: $scope.user.id,
        token_type: 'DayOff'
      }).then(function(token) {
        $scope.daysOffOverride = token;
        $scope.state.hasDayOffOverride = !!token;
      }, function(response) {
        console.log('Failed to fetch days off tokens', response);
        $scope.daysOffOverride = null;
        $scope.state.hasDayOffOverride = false;
      });

      OverrideTokens.getOne({
        user_id: $scope.user.id,
        token_type: 'Availability'
      }).then(function(token) {
        $scope.availabilityOverride = token;
        $scope.state.hasAvailabilityOverride = !!token;
      }, function(response) {
        console.log('Failed to fetch days off tokens', response);
        $scope.availabilityOverride = null;
        $scope.state.hasAvailabilityOverride = false;
      });
    }

    loadOverrideTokens();

    $scope.grantOverride = function(type) {
      if (type !== 'DayOff' && type !== 'Availability') {
        console.error('Invalid type of override requested');
        return;
      }

      OverrideTokens.create({
        token_type: type,
        user_id: $scope.user.id
      }).then(function(token) {
        if (token.token_type == 'DayOff') {
          $scope.daysOffOverride = token;
          $scope.state.hasDayOffOverride = true;
        } else if (token.token_type == 'Availability') {
          $scope.availabilityOverride = token;
          $scope.state.hasAvailabilityOverride = true;
        }
      }, function(response) {
        console.log('Failed to create override token for ' + type);
      });
    };

    $scope.revokeOverride = function(type) {
      var token;
      if (type == 'DayOff') {
        token = $scope.daysOffOverride;
      } else if (type == 'Availability') {
        token = $scope.availabilityOverride;
      } else {
        console.error('Invalid type of override requested');
        return;
      }

      OverrideTokens.revoke(token.id)
        .then(function(token) {
          loadOverrideTokens();
        }, function(response) {
          console.log('Failed to revoke override token for ' + type);
        });
    };

    WorkPeriods.getByUserId($scope.user.id)
      .then(function(workPeriods) {
        $scope.workPeriods = _.where(workPeriods, function(wp) {
          return wp.$isPublished();
        });


        if ($scope.workPeriods.length > 0) {

          var maxStartDate = _.max(
            _.where($scope.workPeriods, function(x) {return x.$isPublished();}),
            function(wp) {
              return wp.start_time.unix();
            }).start_time;

          var arrayOfWeeks = (function() {
            var weeks, loopWeek;
            loopWeek = $scope.currentWeek;
            weeks = [];

            do {
              weeks.push(loopWeek);
              loopWeek = moment(loopWeek.start).add(1,'weeks').twix(moment(loopWeek.end).add(1,'weeks'));
            } while ( maxStartDate.unix() > loopWeek.start.unix() );

            return weeks;
          }());

          //console.log(arrayOfWeeks);


          $scope.workPeriodsByWeek = _.map(arrayOfWeeks, function(weekTwix) {
            return {
              weekTwix: weekTwix,
              workPeriods: _.sortBy(_.where($scope.workPeriods, function(wp) {
                return wp.$isPublished() && weekTwix.contains(wp.start_time) &&
                  weekTwix.overlaps(wp.range_twix) &&
                  weekTwix.intersection(wp.range_twix).length('minutes') > 0;
              }), '_startTimeUnix')
            };
          });

          $scope.objectsToRender = (function() {
            var beginningOfFamine;
            var objList = [];
            _.each($scope.workPeriodsByWeek, function(weekObj, idx, collection) {
              if (weekObj.workPeriods.length > 0) {
                if (!_.isUndefined(beginningOfFamine) && !_.isNull(beginningOfFamine)) {
                  objList.push({
                    type: 'emptyRegion',
                    range_twix: moment(beginningOfFamine).twix(moment(collection[idx-1].weekTwix.end).subtract(12, 'hours'))
                  });
                  beginningOfFamine = undefined;
                }

                weekObj.type = 'standard';
                objList.push(weekObj);
              } else {
                if (_.isUndefined(beginningOfFamine) || _.isNull(beginningOfFamine)) {
                  beginningOfFamine = weekObj.weekTwix.start;
                }
              }
            });
            return objList;
          }());
        }


        $scope.state.scheduleLoaded = true;
      }, function() {
        console.log('could not get schedule');
      });

  });
